"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertListedMetric = exports.convertMetricFromBackend = void 0;
var sdk_backend_base_1 = require("@gooddata/sdk-backend-base");
var sdk_model_1 = require("@gooddata/sdk-model");
function convertMetricFromBackend(metric) {
    var ref = sdk_model_1.uriRef(metric.meta.uri);
    var meta = metric.meta, content = metric.content;
    return sdk_backend_base_1.newMeasureMetadataObject(ref, function (m) {
        return m
            .id(meta.identifier)
            .uri(meta.uri)
            .title(meta.title)
            .description(meta.summary || "")
            .expression(content.expression)
            .format(content.format || "#,#.##")
            .deprecated(meta.deprecated === "1")
            .isLocked(Boolean(meta.locked))
            .production(Boolean(meta.isProduction))
            .unlisted(Boolean(meta.unlisted));
    });
}
exports.convertMetricFromBackend = convertMetricFromBackend;
function convertListedMetric(metricLink) {
    var ref = sdk_model_1.uriRef(metricLink.link);
    return sdk_backend_base_1.newMeasureMetadataObject(ref, function (m) {
        return m
            .id(metricLink.identifier)
            .uri(metricLink.link)
            .title(metricLink.title || "")
            .description(metricLink.summary || "");
    });
}
exports.convertListedMetric = convertListedMetric;
//# sourceMappingURL=MetricConverter.js.map